export default __webpack_public_path__ + "static/media/main_tea_cup_01.224be631.webp";